/* Copyright (c) 2017 Backpack Health LLC */

class MedliSearchTermModel {

  constructor(data = []) {
    this.data = data;
  }

  identifier() {
    return this.data.id;
  }

  name() {
    return this.data.string;
  }

  hasCanonical() {
    return !!this.data.canonical_string;
  }

  canonicalName() {
    return this.data.canonical_string;
  }

  languageCode() {
    return this.data.language_code;
  }

  hasShortDefinition() {
    return !!this.data.short_definition;
  }

  hasLongDefinition() {
    return !!this.data.long_definition_url;
  }

  hasShortDefinitionSource() {
    return !!this.data.short_definition_source;
  }

  hasLongDefinitionSource() {
    return !!this.data.long_definition_source;
  }

  shortDefinition() {
    return this.data.short_definition;
  }

  shortDefinitionSource() {
    return this.data.short_definition_source;
  }

  longDefinitionSource() {
    return this.data.long_definition_source;
  }

  definitionURL() {
    return this.data.long_definition_url;
  }

  convertForHealthEntry() {
    return {
      id: this.data.id,
      strings: {
        [this.data.language_code]: this.data.string,
      },
    };
  }

  isTrackable() {
    return this.data.trackables > 0;
  }

}

export default MedliSearchTermModel;
